import React, { useEffect, useState } from 'react';
import './FileViewer.css';

const FileViewer = ({ files, onFileSelect, selectedFileIndex }) => {
  const [expandedFile, setExpandedFile] = useState(null);

  useEffect(() => {
    if (files && files.length === 1) {
      onFileSelect(files[0], 0);
      setExpandedFile(0);
    }
  }, [files]);

  const handleFileClick = (file, index) => {
    if (expandedFile === index) {
      setExpandedFile(null);
    } else {
      setExpandedFile(index);
      onFileSelect(file, index);
    }
  };

  const getFileIcon = (fileName) => {
    if (!fileName || typeof fileName !== 'string') {
      return '📄';
    }
    const extension = fileName.split('.').pop().toLowerCase();
    const iconMap = {
      'pdf': '📄',
      'doc': '📝',
      'docx': '📝',
      'txt': '📄',
      'jpg': '🖼️',
      'jpeg': '🖼️',
      'png': '🖼️',
      'gif': '🖼️',
      'mp3': '🎵',
      'wav': '🎵',
      'mp4': '🎬',
      'avi': '🎬',
      'mov': '🎬'
    };
    return iconMap[extension] || '📄';
  };

  const renderFileContent = (file) => {
    if (!file.fileUrl) return null;

    const fileName = file.fileName || 'Arquivo';

    return (
      <div className="file-content-container">
        <iframe 
          src={file.fileUrl}
          className="file-content-iframe"
          title={`Visualização de ${fileName}`}
          onError={(e) => {
            console.error('File load error:', e);
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }}
        />
        <div className="file-content-fallback" style={{display: 'none'}}>
          <div className="file-fallback-content">
            <div className="file-icon-large">{getFileIcon(fileName)}</div>
            <h4>{fileName}</h4>
            <p>Arquivo não pode ser exibido inline</p>
            <a href={file.fileUrl} target="_blank" rel="noopener noreferrer" className="download-link">
              Abrir arquivo em nova aba
            </a>
          </div>
        </div>
      </div>
    );
  };

  if (!files || files.length === 0) {
    return (
      <div className="file-viewer">
        <div className="file-viewer-header">
          <h3>Arquivos Enviados</h3>
        </div>
        <div className="empty-files">
          <div className="empty-icon">📁</div>
          <p>Nenhum arquivo enviado</p>
        </div>
      </div>
    );
  }

  return (
    <div className="file-viewer">
      <div className="file-viewer-header">
        <h3>Arquivos Enviados ({files.length})</h3>
      </div>
      
      {expandedFile !== null ? (
        /* File Content View */
        <div className="file-content-view">
          <div className="file-content-header">
            <button 
              className="back-button"
              onClick={() => setExpandedFile(null)}
              title="Voltar para lista de arquivos"
            >
              ← Voltar
            </button>
            <span className="file-content-title">
              {files[expandedFile].fileName || 'Arquivo'}
            </span>
          </div>
          <div className="file-content-body">
            {renderFileContent(files[expandedFile])}
          </div>
        </div>
      ) : (
        /* File Grid View */
        <div className="file-grid">
          {files.map((file, index) => {
            const fileName = file.fileName || 'Arquivo sem nome';
            
            return (
              <div 
                key={index} 
                className={`file-grid-item ${selectedFileIndex === index ? 'selected' : ''}`}
                onClick={() => handleFileClick(file, index)}
              >
                <div className="file-grid-icon">
                  {getFileIcon(fileName)}
                </div>
                <div className="file-grid-info">
                  <div className="file-grid-name" title={fileName}>
                    {fileName}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default FileViewer;